import { Injectable } from '@angular/core';
import { AssessmentSiteTypes } from '../constants-types/Enums';
import { PI } from '../constants-types/PI.model';
import {
    InvitationSource,
    BAInvitationQueryParam
} from '../core-data-model/Assessment.model';
import { Company } from '../core-data-model/Company.model';
import { AssessmentsApi } from '../core-services/AssessmentsApi.connect';
import { CompaniesDataService } from '../core-services/Companies.dataservice';
import { ContextDataService } from '../core-services/Context.dataservice';
import { FoldersDataService } from '../core-services/Folders.dataservice';
import { PersonApi } from '../core-services/PersonApi.connect';
import { InitDataService } from '../system-services/InitData/InitData.service';
import { Logger } from '../system-services/Logger/Logger.service';

@Injectable({
    providedIn: 'root'
})
export class SkipOrLaunchBaService {
    currentCompany: Company;

    constructor(
        private initData: InitDataService,
        private folderService: FoldersDataService,
        private personApi: PersonApi,
        private context: ContextDataService,
        private companyService: CompaniesDataService,
        private logger: Logger,
        private assessmentsApi: AssessmentsApi
    ) {}

    async createPersonAndGenerateBA(
        invitationSource: InvitationSource,
        invitationQueryParam: BAInvitationQueryParam
    ) {
        try {
            // If the Person already exists it might also have a pending assessment
            // If it does, we'll just return that ID, if it doesn't, we'll still skip person creation
            if (this.initData.user.surveyUserId) {
                const existingAssessmentId = await this.findAndSetPerson(
                    this.initData.user.surveyUserId
                );
                if (existingAssessmentId) {
                    return existingAssessmentId;
                }
                const folder =
                    await this.folderService.getUncategorizedEmployeesFolder();
                const assessment =
                    await this.assessmentsApi.GenerateBehavioralAssessmentForAssessmentTaker(
                        invitationSource,
                        folder.id
                    );
                return assessment.assessmentId;
            }
        } catch (error) {
            this.logger.logError('Unable to generate BA link', {
                source: invitationSource,
                queryParam: invitationQueryParam,
                errorMessage: error
            });
            throw error;
        }
    }

    private async findAndSetPerson(id: string): Promise<string> {
        return this.personApi.getPersonDetails([id]).then((persons) => {
            const person = persons[0];
            this.context.addToResultSet(person);
            if (person && person.behavioralAssessments) {
                const existingAssessment = person.behavioralAssessments.find(
                    (x) => x.assessmentState === 10 // Pending state.
                );
                return existingAssessment?.id;
            } else {
                return null;
            }
        });
    }

    async getBALink(
        assessmentId: string,
        invitationQueryParam: BAInvitationQueryParam
    ) {
        this.currentCompany =
            await this.companyService.getCurrentLoggedInCompany();
        const param = invitationQueryParam ? `p=${invitationQueryParam}` : '';

        return `${PI.appSettings.assessmentSite}/v1/${this.currentCompany?.id}/${assessmentId}?type=${AssessmentSiteTypes.EmailInviteBehavioral}&${param}`;
    }
}
